<template>
  <div class="my-3" id="errorView">
    <!-- General Errors -->
    <div v-if="generalError" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
      <span class="block sm:inline">{{ generalError }}</span>
    </div>

    <!-- Validation Errors -->
    <div v-if="validationErrors && Object.keys(validationErrors).length > 0" class="space-y-2 mt-3">
      <div v-for="(errors, field) in validationErrors" :key="field" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
        <strong class="font-bold capitalize">{{ formatField(field) }}</strong>
          <template v-if="Array.isArray(errors)">
        <span v-for="(error, index) in errors" :key="index" class="block sm:inline"> - {{ error }}</span>
          </template>
            <template v-else>
                <span class="block sm:inline"> - {{ errors }}</span>
            </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    generalError: {
      type: [String, Array],
      default: ''
    },
    validationErrors: {
      type: Object,
      default: () => ({})
    }
  },
    methods: {
      formatField(field) {
        return field.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
      }
    },
    watch: {
      generalError() {
        this.$nextTick(() => {
          this.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        })
      },
      validationErrors() {
        this.$nextTick(() => {
          this.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        })
      }
    }
}
</script>

<style scoped>
/* Additional styles if needed */
</style>
